import React, { useState } from 'react';
import { handleUpgrade } from '../utils/handleUpgrade';

export default function UpgradeButton({ children = 'Upgrade to Pro', promoCode = null, className = '' }) {
  const [loading, setLoading] = useState(false);

  const onClick = (e) => {
    e.preventDefault();
    handleUpgrade({ setLoading, promoCode });
  };

  return (
    <button
      type="button"
      onClick={onClick}
      className={`btn ${className}`}
      disabled={loading}
    >
      {loading ? 'Redirecting...' : children}
    </button>
  );
}
